import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { BackofficeService } from "../../services/backoffice.service";
import {
  closeAlertAction,
  showAlertAction,
} from "../../store/actions/alert.action";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
import { IAppState } from "../../store/state/app.state";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { merge, Observable, of as observableOf } from "rxjs";
import { catchError, map, startWith, switchMap } from "rxjs/operators";
import { iconsLibrary } from "../../../theme/constants";
import { MatTableDataSource } from "@angular/material/table";
import { StateService } from "../../services/state.service";

@Component({
  selector: "cowing-core-backoffice-coworkings",
  templateUrl: "./backoffice-coworkings.component.html",
  styleUrls: ["./backoffice-coworkings.component.scss"],
})
export class BackofficeCoworkingsComponent implements AfterViewInit, OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  resultsLength: any;
  coworkingStates: any;

  constructor(
    private _store: Store<IAppState>,
    private translate: TranslateService
  ) {}
  public displayedColumns: string[] = [];
  public dataSource = null;
  private buildCoworking(data) {
    return {
      id: data.id,
      business_group: data.business_group,
      business_name: data.business_name,
      company_name: data.company_name,
      description: data.description,
      email: data.email,
      fiscal_address: data.fiscal_address,
      phone: data.phone,
      tax_id: data.tax_id,
      web: data.web,
      state_id: data.state_id,
    };
  }
  async ngOnInit() {
    await this.getStates();
  }
  async ngAfterViewInit() {
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this._store.dispatch(showLoadingAction({}));
          return BackofficeService.instance.getCoworkings({
            page: this.paginator.pageIndex,
            pageSize: this.paginator.pageSize,
          });
        }),
        map((data) => {
          this._store.dispatch(closeLoadingAction({}));
          this.resultsLength = data.total_elements;
          return data["coworkings"];
        }),
        catchError((e) => {
          this._store.dispatch(
            showAlertAction({
              payload: {
                message: e.error,
                title: this.translate.instant("general.caution"),
                type: "error",
              },
            })
          );
          this._store.dispatch(closeLoadingAction({}));
          return observableOf([]);
        })
      )
      .subscribe((data) => {
        const dataFiltered = data.map((coworking) =>
          this.buildCoworking(coworking)
        );
        if (!this.displayedColumns.length) {
          this.displayedColumns = Object.keys(dataFiltered[0]);
          this.displayedColumns.push("actions");
        }
        this.dataSource = new MatTableDataSource(dataFiltered);
      });
  }
  async getStates() {
    this.coworkingStates = await StateService.instance.getStates(2);
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  public async changeStatus(newStatus, companyId) {
    this._store.dispatch(showLoadingAction({}));
    try {
      const response = await BackofficeService.instance.changeCoworkingStatus(
        companyId,
        newStatus.value
      );
    } catch (e) {
      this._store.dispatch(
        showAlertAction({
          payload: {
            message: e.error,
            title: this.translate.instant("general.caution"),
            type: "error",
          },
        })
      );
    } finally {
      this.paginator.page.emit();
      this._store.dispatch(closeLoadingAction({}));
    }
  }
  public editCoworking(coworking) {
    this._store.dispatch(
      showAlertAction({
        payload: {
          message: null,
          title: null,
          type: "editCoworking",
          editCoworkingId: coworking.id,
        },
      })
    );
  }

  public deleteCoworking(coworking) {
    // this._store.dispatch(
    //   showAlertAction({
    //     payload: {
    //       message: "",
    //       title: "Â¿Desea eliminar esta compaÃ±ia?",
    //       type: "deleteCompany",
    //       deleteCompanyId: company.id,
    //     },
    //   })
    // );
  }

  public get getEditIcon() {
    return `${iconsLibrary.editBackoffice}`;
  }
  public get getDeleteIcon() {
    return `${iconsLibrary.trashBackoffice}`;
  }
}
